export interface TemplateRefreshParams {
  token: string;
  platformId?: string;
  clientId?: string;
  templateCategory?: "OPTUM" | "PLATFORM" | "CLIENT";
}

/**
 * Builds the params object used to dispatch getTemplatesRequested after any
 * mutating operation (clone, rename, delete, move, save-as-draft, activate).
 */
export function buildRefreshParams(
  token: string,
  accountId: string | null | undefined,
  clientId: string | null | undefined,
): TemplateRefreshParams {
  const params: TemplateRefreshParams = { token };
  if (accountId) params.platformId = accountId;
  if (clientId) params.clientId = clientId;
  params.templateCategory =
    accountId && clientId ? "CLIENT" : accountId ? "PLATFORM" : "OPTUM";
  return params;
}
